import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { ScholarshipData, ScholarshipDataAPI } from './scholarship-service-types'
import { transformScholarshipData } from './scholarship-service-utils'
import { NamingStrategy } from '@/infra/http/http-service-client/http-service-client-types'

export const createScholarshipAdminService = (client = httpServiceClient) => ({
  async fetchScholarships(authorizationId: number): Promise<ScholarshipData | null> {
    const response = await client<ScholarshipDataAPI>({
      method: 'get',
      url: makeApiUrl('/v2/admin/scholarships'),
      params: {
        authorization_id: authorizationId
      },
      paramsNamingStrategy: NamingStrategy.snakeCase
    })

    return transformScholarshipData(response.body.data as ScholarshipDataAPI)
  },

  async confirmScholarship(id: string): Promise<void> {
    await client<void>({
      method: 'post',
      url: makeApiUrl(`/v2/admin/scholarships/${id}/confirm`)
    })
  },

  async completeScholarship(id: string): Promise<void> {
    await client<void>({
      method: 'post',
      url: makeApiUrl(`/v2/admin/scholarships/${id}/complete`)
    })
  }
})

export const scholarshipAdminService = createScholarshipAdminService()
